import React from 'react';
import Pane from "../Pane.js";
import Text from "../Text.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function DefaultNodeRenderer(props) {
  const {
    data,
    preCmp: PreCmp,
    postCmp: PostCmp
  } = props;
  const {
    title
  } = data;
  return /*#__PURE__*/_jsxs(Pane, {
    layout: "flex:rowM",
    children: [PreCmp ? /*#__PURE__*/_jsx(PreCmp, {
      ...props
    }) : null, /*#__PURE__*/_jsx(Text, {
      children: title
    }), PostCmp ? /*#__PURE__*/_jsx(PostCmp, {
      ...props
    }) : null]
  });
}